import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
} from "devextreme-react/data-grid";
import { FillFilters, FormatPhoneNumber, loadLookupFromDataSource } from '../../../../common/Utils'
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "A3912FCB-6C32-4552-9317-07861469DFCD";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);

    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
 const initialFormFields = {
        creationdatetime: null,
        record: null,
        creationuserid: null,
        lastupdatedatetime: null,
        lastupdateuserid: null,
        profilecode: null,
        description: null,
        companyid: null,
        module: null,
        recordtype: null,
        lotcodedefaultmethod: null,
        itemavailablewindow: null,
        customercreditlimit: null,
        confirmuserid: null,
        transactionnumbermethod: null,
        pricebasis: null,
        showprintwarning: null,
        pricelevelwarning: null,
        shipmentidmethod: null,
        factored: null,
        transactioncreditlimit: null,
        monthlycreditlimit: null,
        userdefinedcode1: null,
        userdefinedcode2: null,
        userdefinedcode3: null,
        userdefinedcode4: null,
        userdefinedcode5: null,
        uselocation: null,
        popupmessage: null,
        salespersonwarning: null,
        itemsalesdates: null,
        lotmethodshipments: null,
        lotpicksequenceshipments: null,
        botransactionnumbermethod: null,
        lotselectiontiming: null,
        allownegavlitem: null,
        locationmethod: null,
        fromstageitem: null,
        allownegavllocation: null,
        fromstagelocation: null,
        defaulttax: null,
        defaultpricelevel: null,
        fmtransfertiming: null,
        defaultsalesperson: null,
        stagewarning: null,
        creditcheckonstagechange: null,
        accommitunits: null,
        sptransactiondateflag: null,
        defaultfxdata: null,
        usealternatedescription: null,
        uselinenumbers: null,
        spreferencefieldflag: null,
        discountbasis: null,
        allowduplicatepo: null,
        shiptolookup: null,
        artradediscountflag: null,
        artermsdiscountflag: null,
        unitofmeasure: null,
        userdefinedcodedetail1: null,
        userdefinedcodedetail2: null,
        userdefinedcodedetail3: null,
        userdefinedcodedetail4: null,
        userdefinedcodedetail5: null,
        readonlywebfromstage: null,
        presetlotcode: null,
        checkkitavailability: null,
        kitdetailusage: null,
        ardescriptionflag: null,
        kitdetailusageadjustment: null,
        ponumberfrom: null,
        ponumberto: null,
        ponumberlast: null,
        ponumberexpiration: null,
        ponumberincrement: null,
        itemvisibility: null,
        ponumbermethod: null,
        consigneepriceschedulewh: null,
        customerpriceschedulewh: null,
        checkduplicateitems: null,
        approval: null,
        discpricewarning: null,
        usecommitdateforfyfp: null,
        associatesalespeople: null,
        usequantity: null,
        unitpricefromdate: null,
        usequantitychange: null,
        checkduplicatetrans: null,
        separatefreight: null,
        defaultinvdate: null,
        quantitycheck: null,
        datevalidation: null,
        allowuservalidation: null,
        createdocontents: null,
        poreqdropship: null,
        poreqbackordered: null,
        poreqpurchased: null,
        poreqordered: null,
        printtoprinterinvoice: null,
        printtoprinterpackingslip: null,
        printtoprinterpickingslip: null,
        printtoprintereditreport: null,
        printtoprinterorderacknowledg: null,
        bostatus: null,
        poscategory1: null,
        poscategory2: null,
        poscategory3: null,
        poscategory4: null,
        poscategory5: null,
        poscategory6: null,
        poscategory7: null,
        poscategory8: null,
        poscategory9: null,
        poscategory10: null,
        poscategory11: null,
        poscategory12: null,
        posgiftcategory: null,
        posnewgiftcard: null,
        posaddvaluegiftcard: null,
        usediscountfromvcr: null,
        displaydiscountfromvcr: null,
        datevalidationuddates: null,
        itemlotnetavailwarning: null,
        selectitemsfilter1: null,
        selectitemsfilter2: null,
        selectitemsfilter3: null,
        selectitemsfilter4: null,
        rapidentry: null,
        rapidentrystage: null,
        accessfreight: null,
        autocalcfreight: null,
        ptrassignedstageflag: null,
        inventoryreview: null,
        itembuilderflag: null,
        fmtransferstage: null,
        includediscountinunitprice: null,
        detailstatus: null,
        displaycustomfees: null,
        displaycustomfeestab: null,
        usercustomfeesp: null,
        splitoption: null,
        importdetaillinestage: null
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].RowId;
        }
        else {
            rowId.current = '';
        }

        setIsEditButtonDisabled(!isEditButtonDisabled);
    };

    const handelEditClick = () => {
        const buttonUrl = "/om/data-profiles/salesorder-profile-data-entry-edit?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();
        const { IDTYPE, ...filteredFormFields } = formFields;
        const filters = FillFilters(filteredFormFields);
        datasource.filter(filters);
        setResultData(datasource);
    }
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setResultData(loadDatasource);
    }
    useEffect(() => {
        setResultData(loadDatasource);
    }, []);

    const handleFormLoad = useCallback(() => {
        const statuses = [{ id: 'O', text: 'Open' }, { id: 'H', text: 'Hold' }, { id: 'R', text: 'Ready To Commit Later' }];
        var stages = [
            { id: "L", text: "Canceled - No Inventory Effect" },
            { id: "Q", text: "Quote - No Inventory Effect" },
            { id: "P", text: "Plan - No Inventory Effect" },
            { id: "F", text: "Future - No Effect On Net Available" },
            { id: "N", text: "Pending - Effects Net Available" },
            { id: "A", text: "Assigned - Effect Available" },
            { id: "S", text: "Picked/Staged - Effect Available" },
            { id: "C", text: "Shipped/Completed - Effect Available" }
        ];
        var transactionTypes = [
            { id: "I", text: "Order/Invoice - Inventory Effect" },
            { id: "C", text: "Credit - Inventory Effect" },
            { id: "J", text: "$ Adjustment - No Inventory Effect - AR Credit" }];
        loadLookupFromStaticData(formRefs, "STATUS", statuses);
        loadLookupFromStaticData(formRefs, "STAGE", stages);
        loadLookupFromStaticData(formRefs, "TRANSACTIONTYPE", transactionTypes);

    }, []);
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'text');
            formRefs.current[name].instance().option('displayExpr', 'text');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };

    const handleFieldChange = useCallback((name, value) => {
        // console.log(name, value);
    }, []);


    const loadDatasource = () => {
        let store = createStore({
            key: 'RowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/om/TransactionDp/GetSalesOrderProfiles`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    }
    const [resultData, setResultData] = useState(null);


    const handleValueChanged = (e) => {
        console.log(e)
    }

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                          Transaction Profile Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='E6799C37-0F37-4FA0-BB17-E463376BF37B'
                                layoutName='OMSalesOrderDataProfile'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            remoteOperations={true}
                            searchEnabled={true}
                            columnAutoWidth={true}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                            />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            {/* Columns with manually spaced captions */}
                            <Column visible={false} dataType="datetime" dataField="CreationDatetime" caption="Creation Date Time" />
                            <Column  dataType="string" dataField="Record" caption="Record" />
                            <Column visible={false} dataType="string" dataField="CreationUserId" caption="Created By" />
                            <Column visible={false} dataType="datetime" dataField="LastUpdateDatetime" caption="Last Update Date Time" />
                            <Column visible={false} dataType="string" dataField="LastUpdateUserId" caption="Last Updated User" />
                            <Column  dataType="string" dataField="ProfileCode" caption="Profile" />
                            <Column  dataType="string" dataField="Description" caption="Description" />
                            <Column visible={false} dataType="string" dataField="CompanyId" caption="Company Id" />
                            <Column visible={false} dataType="string" dataField="Module" caption="Module" />
                            <Column visible={false} dataType="string" dataField="RecordType" caption="Record Type" />
                            <Column visible={false} dataType="string" dataField="LotCodeDefaultMethod" caption="Lot Code Default Method" />
                            <Column visible={false} dataType="string" dataField="ItemAvailableWindow" caption="Item Available Window" />
                            <Column visible={false} dataType="string" dataField="CustomerCreditLimit" caption="Customer Credit Limit" />
                            <Column visible={false} dataType="string" dataField="ConfirmUserId" caption="Confirm User Id" />
                            <Column visible={false} dataType="string" dataField="TransactionNumberMethod" caption="Transaction Number Method" />
                            <Column visible={false} dataType="string" dataField="PriceBasis" caption="Price Basis" />
                            <Column visible={false} dataType="string" dataField="ShowPrintWarning" caption="Show Print Warning" />
                            <Column visible={false} dataType="string" dataField="PriceLevelWarning" caption="Price Level Warning" />
                            <Column visible={false} dataType="string" dataField="ShipmentIdMethod" caption="Shipment Id Method" />
                            <Column visible={false} dataType="string" dataField="Factored" caption="Factored" />
                            <Column visible={false} dataType="string" dataField="TransactionCreditLimit" caption="Transaction Credit Limit" />
                            <Column visible={false} dataType="string" dataField="MonthlyCreditLimit" caption="Monthly Credit Limit" />
                            <Column  dataType="string" dataField="UserDefinedCode1" caption="Code 1" />
                            <Column  dataType="string" dataField="UserDefinedCode2" caption="Code 2" />
                            <Column  dataType="string" dataField="UserDefinedCode3" caption="Code 3" />
                            <Column  dataType="string" dataField="UserDefinedCode4" caption="Code 4" />
                            <Column  dataType="string" dataField="UserDefinedCode5" caption="Code 5" />
                            <Column visible={false} dataType="string" dataField="UseLocation" caption="Use Location" />
                            <Column visible={false} dataType="string" dataField="PopupMessage" caption="Popup Message" />
                            <Column visible={false} dataType="string" dataField="SalespersonWarning" caption="Salesperson Warning" />
                            <Column visible={false} dataType="string" dataField="ItemSalesDates" caption="Item Sales Dates" />
                            <Column visible={false} dataType="string" dataField="LotMethodShipments" caption="Lot Method Shipments" />
                            <Column visible={false} dataType="string" dataField="LotPickSequenceShipments" caption="Lot Pick Sequence Shipments" />
                            <Column visible={false} dataType="string" dataField="BOTransactionNumberMethod" caption="BO Transaction Number Method" />
                            <Column visible={false} dataType="string" dataField="LotSelectionTiming" caption="Lot Selection Timing" />
                            <Column visible={false} dataType="string" dataField="AllowNegAvlItem" caption="Allow Neg Avl Item" />
                            <Column visible={false} dataType="string" dataField="LocationMethod" caption="Location Method" />
                            <Column visible={false} dataType="string" dataField="FromStageItem" caption="From Stage Item" />
                            <Column visible={false} dataType="string" dataField="AllowNegAvlLocation" caption="Allow Neg Avl Location" />
                            <Column visible={false} dataType="string" dataField="FromStageLocation" caption="From Stage Location" />
                            <Column visible={false} dataType="string" dataField="DefaultTax" caption="Default Tax" />
                            <Column visible={false} dataType="string" dataField="DefaultPriceLevel" caption="Default Price Level" />
                            <Column visible={false} dataType="string" dataField="FMTransferTiming" caption="FM Transfer Timing" />
                            <Column visible={false} dataType="string" dataField="DefaultSalesperson" caption="Default Salesperson" />
                            <Column visible={false} dataType="string" dataField="StageWarning" caption="Stage Warning" />
                            <Column visible={false} dataType="string" dataField="CreditCheckOnStageChange" caption="Credit Check On Stage Change" />
                            <Column visible={false} dataType="string" dataField="ACCommitUnits" caption="AC Commit Units" />
                            <Column visible={false} dataType="string" dataField="SPTransactionDateFlag" caption="SP Transaction Date" />
                            <Column visible={false} dataType="string" dataField="DefaultFXData" caption="Default FX Data" />
                            <Column visible={false} dataType="string" dataField="UseAlternateDescription" caption="Use Alternate Description" />
                            <Column visible={false} dataType="string" dataField="UseLineNumbers" caption="Use Line Numbers" />
                            <Column visible={false} dataType="string" dataField="SPReferenceFieldFlag" caption="SP Reference Field" />
                            <Column visible={false} dataType="string" dataField="DiscountBasis" caption="Discount Basis" />
                            <Column  dataType="string" dataField="AllowDuplicatePO" caption="Allow Duplicate PO">
                                <Lookup
                                    dataSource={[{ ID: 'Y', Text: 'Yes' }, { ID: 'N', Text: 'No' }]}
                                    displayExpr="Text"
                                    valueExpr="ID"
                                />
                            </Column>
                            <Column visible={false} dataType="string" dataField="ShipToLookup" caption="Ship To" />
                            <Column dataType="string" dataField="ARTradeDiscountFlag" caption="AR Trade Discount">
                                <Lookup
                                    dataSource={[{ ID: 'Y', Text: 'Yes' }, { ID: 'N', Text: 'No' }]}
                                    displayExpr="Text"
                                    valueExpr="ID"
                                />
                            </Column>
                            <Column dataType="string" dataField="ARTermsDiscountFlag" caption="AR Terms" >
                                <Lookup
                                    dataSource={[{ ID: 'Y', Text: 'Yes' }, { ID: 'N', Text: 'Not Applicable' }]}
                                    displayExpr="Text"
                                    valueExpr="ID"
                                />
                            </Column>
                            <Column visible={false} dataType="string" dataField="UnitOfMeasure" caption="Unit Of Measure" />
                            <Column visible={false} dataType="string" dataField="UserDefinedCodeDetail1" caption="Code Detail 1" />
                            <Column visible={false} dataType="string" dataField="UserDefinedCodeDetail2" caption="Code Detail 2" />
                            <Column visible={false} dataType="string" dataField="UserDefinedCodeDetail3" caption="Code Detail 3" />
                            <Column visible={false} dataType="string" dataField="UserDefinedCodeDetail4" caption="Code Detail 4" />
                            <Column visible={false} dataType="string" dataField="UserDefinedCodeDetail5" caption="Code Detail 5" />
                            <Column visible={false} dataType="string" dataField="ReadOnlyWebFromStage" caption="Readonly Web From Stage" />
                            <Column visible={false} dataType="string" dataField="PresetLotCode" caption="Preset Lot Code" />
                            <Column visible={false} dataType="string" dataField="CheckKitAvailability" caption="Check Kit Availability" />
                            <Column visible={false} dataType="string" dataField="KitDetailUsage" caption="Kit Detail Usage" />
                            <Column visible={false} dataType="string" dataField="ARDescriptionFlag" caption="AR Description Flag" />
                            <Column visible={false} dataType="string" dataField="KitDetailUsageAdjustment" caption="Kit Detail Usage Adjustment" />
                            <Column visible={false} dataType="string" dataField="PONumberFrom" caption="PO Number From" />
                            <Column visible={false} dataType="string" dataField="PONumberTo" caption="PO Number To" />
                            <Column visible={false} dataType="string" dataField="PONumberLast" caption="PO Number Last" />
                            <Column visible={false} dataType="string" dataField="PONumberExpiration" caption="PO Number Expiration" />
                            <Column visible={false} dataType="string" dataField="PONumberIncrement" caption="PO Number Increment" />
                            <Column visible={false} dataType="string" dataField="ItemVisibility" caption="Item Visibility" />
                            <Column visible={false} dataType="string" dataField="PONumberMethod" caption="PO Number Method" />
                            <Column visible={false} dataType="string" dataField="ConsigneePriceScheduleWh" caption="Consignee Price Schedule Wh" />
                            <Column visible={false} dataType="string" dataField="CustomerPriceScheduleWh" caption="Customer Price Schedule Wh" />
                            <Column visible={false} dataType="string" dataField="CheckDuplicateItems" caption="Check Duplicate Items" />
                            <Column visible={false} dataType="string" dataField="Approval" caption="Approval" />
                            <Column visible={false} dataType="string" dataField="DiscPriceWarning" caption="Disc Price Warning" />
                            <Column visible={false} dataType="string" dataField="UseCommitDateForFYFP" caption="Use Commit Date For FYFP" />
                            <Column visible={false} dataType="string" dataField="AssociateSalesPeople" caption="Associate Sales People" />
                            <Column visible={false} dataType="string" dataField="UseQuantity" caption="Use Quantity" />
                            <Column visible={false} dataType="string" dataField="UnitPriceFromDate" caption="Unit Price From Date" />
                            <Column visible={false} dataType="string" dataField="UseQuantityChange" caption="Use Quantity Change" />
                            <Column visible={false} dataType="string" dataField="CheckDuplicateTrans" caption="Check Duplicate Trans" />
                            <Column visible={false} dataType="string" dataField="SeparateFreight" caption="Separate Freight" />
                            <Column visible={false} dataType="string" dataField="DefaultInvDate" caption="Default Inv Date" />
                            <Column visible={false} dataType="string" dataField="QuantityCheck" caption="Quantity Check" />
                            <Column visible={false} dataType="string" dataField="DateValidation" caption="Date Validation" />
                            <Column visible={false} dataType="string" dataField="AllowUserValidation" caption="Allow User Validation" />
                            <Column visible={false} dataType="string" dataField="CreateDOContents" caption="Create DO Contents" />
                            <Column visible={false} dataType="string" dataField="POReqDropship" caption="PO Req Dropship" />
                            <Column visible={false} dataType="string" dataField="POReqBackOrdered" caption="PO Req Backordered" />
                            <Column visible={false} dataType="string" dataField="POReqPurchased" caption="PO Req Purchased" />
                            <Column visible={false} dataType="string" dataField="POReqOrdered" caption="PO Req Ordered" />
                            <Column visible={false} dataType="string" dataField="PrintToPrinterInvoice" caption="Print To Printer Invoice" />
                            <Column visible={false} dataType="string" dataField="PrintToPrinterPackingSlip" caption="Print To Printer Packing Slip" />
                            <Column visible={false} dataType="string" dataField="PrintToPrinterPickingSlip" caption="Print To Printer Picking Slip" />
                            <Column visible={false} dataType="string" dataField="PrintToPrinterEditReport" caption="Print To Printer Edit Report" />
                            <Column visible={false} dataType="string" dataField="PrintToPrinterOrderAcknowledge" caption="Print To Printer Order Acknowledge" />
                            <Column visible={false} dataType="string" dataField="BOStatus" caption="BO Status" />
                            <Column visible={false} dataType="string" dataField="POSCategory1" caption="POS Category 1" />
                            <Column visible={false} dataType="string" dataField="POSCategory2" caption="POS Category 2" />
                            <Column visible={false} dataType="string" dataField="POSCategory3" caption="POS Category 3" />
                            <Column visible={false} dataType="string" dataField="POSCategory4" caption="POS Category 4" />
                            <Column visible={false} dataType="string" dataField="POSCategory5" caption="POS Category 5" />
                            <Column visible={false} dataType="string" dataField="POSCategory6" caption="POS Category 6" />
                            <Column visible={false} dataType="string" dataField="POSCategory7" caption="POS Category 7" />
                            <Column visible={false} dataType="string" dataField="POSCategory8" caption="POS Category 8" />
                            <Column visible={false} dataType="string" dataField="POSCategory9" caption="POS Category 9" />
                            <Column visible={false} dataType="string" dataField="POSCategory10" caption="POS Category 10" />
                            <Column visible={false} dataType="string" dataField="POSCategory11" caption="POS Category 11" />
                            <Column visible={false} dataType="string" dataField="POSCategory12" caption="POS Category 12" />
                            <Column visible={false} dataType="string" dataField="POSGiftCategory" caption="POS Gift Category" />
                            <Column visible={false} dataType="string" dataField="POSNewGiftCard" caption="POS New Gift Card" />
                            <Column visible={false} dataType="string" dataField="POSAddValueGiftCard" caption="POS Add Value Gift Card" />
                            <Column visible={false} dataType="string" dataField="UseDiscountFromVCR" caption="Use Discount From VCR" />
                            <Column visible={false} dataType="string" dataField="DisplayDiscountFromVCR" caption="Display Discount From VCR" />
                            <Column visible={false} dataType="string" dataField="DateValidationUDDates" caption="Date Validation UD Dates" />
                            <Column visible={false} dataType="string" dataField="ItemLotNetAvailWarning" caption="Item Lot Net Avail Warning" />
                            <Column visible={false} dataType="string" dataField="SelectItemsFilter1" caption="Select Items Filter 1" />
                            <Column visible={false} dataType="string" dataField="SelectItemsFilter2" caption="Select Items Filter 2" />
                            <Column visible={false} dataType="string" dataField="SelectItemsFilter3" caption="Select Items Filter 3" />
                            <Column visible={false} dataType="string" dataField="SelectItemsFilter4" caption="Select Items Filter 4" />
                            <Column visible={false} dataType="string" dataField="RapidEntry" caption="Rapid Entry" />
                            <Column visible={false} dataType="string" dataField="RapidEntryStage" caption="Rapid Entry Stage" />
                            <Column  dataType="string" dataField="AccessFreight" caption="Access Freight" >
                                <Lookup
                                    dataSource={[{ ID: 'Y', Text: 'Yes' }, { ID: 'N', Text: 'No' }]}
                                    displayExpr="Text"
                                    valueExpr="ID"
                                />
                            </Column>
                            <Column visible={false} dataType="string" dataField="AutoCalcFreight" caption="Auto Calc Freight" />
                            <Column visible={false} dataType="string" dataField="PTRAssignedStageFlag" caption="PTR Assigned Stage Flag" />
                            <Column visible={false} dataType="string" dataField="InventoryReview" caption="Inventory Review" />
                            <Column visible={false} dataType="string" dataField="ItemBuilderFlag" caption="Item Builder Flag" />
                            <Column visible={false} dataType="string" dataField="FMTransferStage" caption="FM Transfer Stage" />
                            <Column visible={false} dataType="string" dataField="IncludeDiscountInUnitPrice" caption="Include Discount In Unit Price" />
                            <Column visible={false} dataType="string" dataField="DetailStatus" caption="Detail Status" />
                            <Column visible={false} dataType="string" dataField="DisplayCustomFees" caption="Display Custom Fees" />
                            <Column visible={false} dataType="string" dataField="DisplayCustomFeesTab" caption="Display Custom Fees Tab" />
                            <Column visible={false} dataType="string" dataField="UserCustomFeeSP" caption="User Custom Fee SP" />
                            <Column visible={false} dataType="string" dataField="SplitOption" caption="Split Option" />
                            <Column visible={false} dataType="string" dataField="ImportDetailLineStage" caption="Import Detail Line Stage" />

                            <GridToolbar>
                                <GridToolbarItem location="before">
                                    <Button
                                        disabled={isEditButtonDisabled}
                                        onClick={handelEditClick}
                                        type="default"
                                        text="Edit"
                                    ></Button>
                                </GridToolbarItem>
                                <GridToolbarItem location="before">
                                    <div>
                                        <Link to="/om/data-profiles/salesorder-profile-data-entry-create">
                                            <Button
                                                type="default"
                                                className="gridTopButton"
                                                text="Create"
                                            ></Button>
                                        </Link>
                                    </div>
                                </GridToolbarItem>
                                <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(List);